import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';
import { Match } from '../../_shared/models/match.model';
import { Server } from '../../_shared/models/point.model';
import { BoardHelpService } from '../../match-tracker/tracker-board/board-help.service';
import { ScoreFormat } from '../../_shared/models/score-format.model';
import { Clock } from '../../_shared/models/clock.model';
import { ClockName } from '../../_shared/models/enums/clock-name.enum';

@Component({
  standalone: false,
  selector: 'app-timed-tennis',
  templateUrl: './timed-tennis.component.html',
  styleUrls: ['./timed-tennis.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class TimedTennisComponent  implements OnInit {
  private bhs = inject(BoardHelpService);

  @Input({ required: true }) match: Match;
  @Input({ required: true }) pointScoreSide1: number;
  @Input({ required: true }) pointScoreSide2: number;
  @Input({ required: true }) server: Server;

  scoreFormat: ScoreFormat;
  setTimer: Clock;
  pointBreakTimer: Clock;

  constructor() { }

  ngOnInit() {
    this.scoreFormat = this.bhs.getScoreFormat(this.match.matchFormat, this.match.discipline);
    this.setTimer = this.match.clocks.find(c => c.name === ClockName.SET_TIME);
    this.pointBreakTimer = this.match.clocks.find(c => c.name === ClockName.POINT_BREAK);
  }

  getParticipantName(sideNumber: number, playerNumber: number) {
    const person = this.match.sides[sideNumber - 1].players[playerNumber - 1].participant;
    if (person) {
      return `${person.last_name?.toUpperCase()}`;
    }
  }

}
